import {LoadIndicator} from "devextreme-react/load-indicator";
import React from "react";

const Load = ({textLoad}) => {
    return (
        <div style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        }}>
            <LoadIndicator id="medium-indicator" height={40} width={40}/>
            <span style={{fontSize: 11, color: 'gray', marginTop: 5}}>{textLoad}</span>
        </div>
    )
}

export default Load